import { connect } from 'react-redux'
import { selectCurrentPhone } from '../App/selectors'
import { selectLandingCategories } from '../FAQs/selectors'
import { Home } from '../../components'
import { createEvent } from '../UserEvents/actions'
import { selectDevices } from '../DeviceSelector/selectors'

const mapStateToProps = (state, ownProps) => ({
  currentPhone: selectCurrentPhone(state),
  location: ownProps.location,
  query: state.routing.locationBeforeTransitions.query,
  isLandingPage: ownProps.isLandingPage,
  expressCategories: selectLandingCategories(state),
  toggleSearchModal: ownProps.toggleSearchModal,
  toggleDeviceModal: ownProps.toggleDeviceModal,
  devices: selectDevices(state),
})

const mapDispatchToProps = dispatch => ({
  createUserEvent: event => dispatch(createEvent(event))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js